import { AviaPassengerFareFragment, CheckoutOrderFragment, FlightFragment, ResultsLegFragment } from '@websky/graphql';
import { Props } from './Flight';
import { SelectedFare } from '../DesktopFlight/types';

type SegmentGroup = CheckoutOrderFragment['flight']['segmentGroups'][0];

export const segmentGroupToResultsLeg = (checkoutFlight: FlightFragment, group: SegmentGroup): ResultsLegFragment => {
	return {
		segments: group.segments.map(segment => {
			return checkoutFlight.segments.find(flightSegment => flightSegment.segment.id === segment.id);
		}),
		pricesForFareGroups: [
			{
				fareFamily: {
					...group.fareFamily
				},
				prices: [
					{
						originalPrice: group.price,
						price: group.price,
						priceInMiles: group.priceInMiles,
						flight: {
							fares: [],
							canBePaidByMiles: false,
							id: checkoutFlight.id,
							subsidized: false
						}
					}
				]
			}
		]
	};
};

export const segmentGroupToSelectedFareAdapter = (flightId: string, group: SegmentGroup): SelectedFare[] => {
	return [
		{
			fareGroupId: group.fareGroup?.id || group.fareFamily?.id,
			prices: [
				{
					flight: {
						fares: [],
						id: flightId
					},
					priceInMiles: group.priceInMiles,
					price: group.price
				}
			]
		}
	];
};

export const segmentGroupToPassengerFares = (
	fares: FlightFragment['fares'],
	group: SegmentGroup
): AviaPassengerFareFragment[] => {
	if (!fares?.length) {
		return [];
	}

	const passengerFares = fares.reduce<AviaPassengerFareFragment[]>(
		(arr, fare) => [...arr, ...(fare?.passengerFares || [])],
		[]
	);

	const groupSegmentIds = new Set(group.segments.map(segment => segment.id));

	return passengerFares.filter(fare => fare.segments?.some(segment => groupSegmentIds.has(segment.id)));
};

export const checkoutSegmentGroupToFlightPropsAdapter = (
	orderId: string,
	flight: FlightFragment,
	group: SegmentGroup,
	confirmed?: boolean,
	canceled?: boolean
): Props => {
	return {
		orderId,
		isSelected: true,
		flight: segmentGroupToResultsLeg(flight, group),
		// price:flight.seatMap.additionalServices.gdsServices.services,
		selectedFares: segmentGroupToSelectedFareAdapter(flight.id, group),
		passengerFares: segmentGroupToPassengerFares(flight.fares, group),
		canceled: canceled,
		paid: confirmed,
		isPreOpenAvailable: false,
		isPreOpen: false,
		isReturnFlight: group.groupId === '1'
	};
};
